/**
 * @generated SignedSource<<fbdbb077f181f4b6e85fdc09e7cc3d65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgeRange = "LT12" | "GT12LT19" | "GT20LT24" | "GT25LT29" | "GT30LT34" | "GT35LT39" | "GT40LT44" | "GT45LT49" | "GT50LT54" | "GT55LT59" | "%future added value";
export type AnnualIncome = "LT200" | "GT200LT400" | "GT400LT600" | "GT600LT800" | "GT800LT1000" | "GT1000LT1200" | "GT1200LT1500" | "GT1500LT2000" | "GT2000" | "%future added value";
export type Browser = "IE" | "CHROME" | "SAFARI" | "FIREFOX" | "EDGE" | "OTHER" | "%future added value";
export type DayOfWeek = "SUN" | "MON" | "TUE" | "WED" | "THU" | "FRI" | "SUT" | "%future added value";
export type DeliverKind = "EQUAL" | "WEIGHT" | "%future added value";
export type Device = "MOBILE" | "TABLET" | "PC" | "%future added value";
export type DistributionStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type Gender = "MALE" | "FEMALE" | "%future added value";
export type GroupContentJudgeStatus = "PENDING" | "APPROVED" | "%future added value";
export type MatchOp = "EQUAL" | "CONTAINS" | "%future added value";
export type Platform = "IOS" | "WINDOWS" | "ANDROID" | "MAC" | "LINUX" | "OTHER" | "%future added value";
export type PopupGroupDisplayTargetContentKind = "ID" | "SELECTOR" | "%future added value";
export type VisitMatch = "EQUAL_MATCH_TYPE" | "OVER_MATCH_TYPE" | "UNDER_MATCH_TYPE" | "%future added value";
export type UpdatePopupGroupInput = {
  clientMutationId?: string | null;
  popupGroupId: string;
  ageRanges?: ReadonlyArray<AgeRange> | null;
  annualIncomes?: ReadonlyArray<AnnualIncome> | null;
  browsers?: ReadonlyArray<Browser> | null;
  deliverDayOfWeeks?: ReadonlyArray<DeliverDayOfWeekInput> | null;
  deliverKind?: DeliverKind | null;
  deliverTargetUrls?: ReadonlyArray<PopupGroupDeliverUrlInput> | null;
  deliverExcludeUrls?: ReadonlyArray<PopupGroupDeliverUrlInput> | null;
  devices?: ReadonlyArray<Device> | null;
  displayTargetContents?: ReadonlyArray<PopupGroupDisplayTargetContentInput> | null;
  disableTargetElements?: ReadonlyArray<PopupGroupDisableTargetElementInput> | null;
  endDate?: string | null;
  excludeReferrers?: ReadonlyArray<PopupGroupExcludeReferrerInput> | null;
  genders?: ReadonlyArray<Gender> | null;
  isContentAnalyticsEnabled?: boolean | null;
  isMulti?: boolean | null;
  judgeStatus?: GroupContentJudgeStatus | null;
  memo?: string | null;
  name?: string | null;
  pageId?: string | null;
  platforms?: ReadonlyArray<Platform> | null;
  redisplayPopupTime?: number | null;
  referrers?: ReadonlyArray<PopupGroupReferrerInput> | null;
  sourceIds?: ReadonlyArray<string> | null;
  excludeSourceIds?: ReadonlyArray<string> | null;
  startDate?: string | null;
  status?: DistributionStatus | null;
  targetCookies?: ReadonlyArray<PopupGroupTargetCookieInput> | null;
  visitCount?: number | null;
  visitMatchType?: VisitMatch | null;
  scheduleIds?: ReadonlyArray<string> | null;
};
export type DeliverDayOfWeekInput = {
  weekOfMonth?: number | null;
  daysOfWeek: ReadonlyArray<DayOfWeek>;
};
export type PopupGroupDeliverUrlInput = {
  url: string;
};
export type PopupGroupDisplayTargetContentInput = {
  targetKind: PopupGroupDisplayTargetContentKind;
  targetValue: string;
};
export type PopupGroupDisableTargetElementInput = {
  targetKind: PopupGroupDisplayTargetContentKind;
  targetValue: string;
};
export type PopupGroupExcludeReferrerInput = {
  referrer: string;
  matchOp: MatchOp;
};
export type PopupGroupReferrerInput = {
  referrer: string;
  matchOp: MatchOp;
};
export type PopupGroupTargetCookieInput = {
  key: string;
  value: string;
  matchType: boolean;
};
export type PopupGroupEditScreenContainer_Mutation$variables = {
  input: UpdatePopupGroupInput;
};
export type PopupGroupEditScreenContainer_MutationVariables = PopupGroupEditScreenContainer_Mutation$variables;
export type PopupGroupEditScreenContainer_Mutation$data = {
  readonly updatePopupGroup: {
    readonly popupGroup: {
      readonly slug: string;
      readonly " $fragmentSpreads": FragmentRefs<"PopupGroupEditScreenContainer_popupGroup">;
    } | null;
  } | null;
};
export type PopupGroupEditScreenContainer_MutationResponse = PopupGroupEditScreenContainer_Mutation$data;
export type PopupGroupEditScreenContainer_Mutation = {
  variables: PopupGroupEditScreenContainer_MutationVariables;
  response: PopupGroupEditScreenContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v3/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "targetKind",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "targetValue",
    "storageKey": null
  },
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  (v6/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "referrer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "matchOp",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupGroupEditScreenContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePopupGroupPayload",
        "kind": "LinkedField",
        "name": "updatePopupGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PopupGroup",
            "kind": "LinkedField",
            "name": "popupGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PopupGroupEditScreenContainer_popupGroup"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupGroupEditScreenContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdatePopupGroupPayload",
        "kind": "LinkedField",
        "name": "updatePopupGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PopupGroup",
            "kind": "LinkedField",
            "name": "popupGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ageRanges",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "annualIncomes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "browsers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DeliverDayOfWeek",
                "kind": "LinkedField",
                "name": "deliverDayOfWeeks",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weekOfMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "daysOfWeek",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PopupGroupDeliverExcludeUrl",
                "kind": "LinkedField",
                "name": "deliverExcludeUrls",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PopupGroupDeliverTargetUrl",
                "kind": "LinkedField",
                "name": "deliverTargetUrls",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deliverKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "devices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PopupGroupDisplayTargetContent",
                "kind": "LinkedField",
                "name": "displayTargetContents",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PopupGroupDisableTargetElement",
                "kind": "LinkedField",
                "name": "disableTargetElements",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "platforms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "genders",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isContentAnalyticsEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMulti",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memo",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "repeat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "page",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Funnel",
                    "kind": "LinkedField",
                    "name": "funnel",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "redisplayPopupTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Source",
                "kind": "LinkedField",
                "name": "sources",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Source",
                "kind": "LinkedField",
                "name": "excludeSources",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PopupGroupExcludeReferrer",
                "kind": "LinkedField",
                "name": "excludeReferrers",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PopupGroupTargetCookie",
                "kind": "LinkedField",
                "name": "targetCookies",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "matchType",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PopupGroupReferrer",
                "kind": "LinkedField",
                "name": "referrers",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visitCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visitMatchType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Schedule",
                "kind": "LinkedField",
                "name": "schedules",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endTime",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c821b7470bc9084da025430bdf8accb",
    "id": null,
    "metadata": {},
    "name": "PopupGroupEditScreenContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation PopupGroupEditScreenContainer_Mutation(\n  $input: UpdatePopupGroupInput!\n) {\n  updatePopupGroup(input: $input) {\n    popupGroup {\n      slug\n      ...PopupGroupEditScreenContainer_popupGroup\n      id\n    }\n  }\n}\n\nfragment PopupGroupEditScreenContainer_popupGroup on PopupGroup {\n  ageRanges\n  annualIncomes\n  browsers\n  deliverDayOfWeeks {\n    weekOfMonth\n    daysOfWeek\n  }\n  deliverExcludeUrls {\n    url\n    id\n  }\n  deliverTargetUrls {\n    url\n    id\n  }\n  deliverKind\n  devices\n  displayTargetContents {\n    targetKind\n    targetValue\n    id\n  }\n  disableTargetElements {\n    targetKind\n    targetValue\n    id\n  }\n  platforms\n  genders\n  id\n  isContentAnalyticsEnabled\n  isMulti\n  memo\n  name\n  repeat\n  endDate\n  page {\n    id\n    funnel {\n      id\n    }\n  }\n  redisplayPopupTime\n  slug\n  sources {\n    id\n    name\n  }\n  excludeSources {\n    id\n    name\n  }\n  startDate\n  status\n  excludeReferrers {\n    referrer\n    matchOp\n  }\n  targetCookies {\n    key\n    value\n    matchType\n    id\n  }\n  referrers {\n    referrer\n    matchOp\n  }\n  visitCount\n  visitMatchType\n  schedules {\n    id\n    startTime\n    endTime\n  }\n}\n"
  }
};
})();

(node as any).hash = "0602bd6f954dbaa7c5a4e6d8eaf6b686";

export default node;
